import { ArrowUpRight, ClipboardList, MessageCircle, Phone, Sparkles } from "lucide-react";
import Reveal from "./Reveal";
import { FORM_URL, PHONE_DISPLAY, PHONE_TEL, WHATSAPP_MSG_URL } from "./data";

const STEPS = [
  { icon: ClipboardList, title: "Fill the 60-second form", text: "Tell us your space size, service and preferred date." },
  { icon: MessageCircle, title: "We confirm on WhatsApp", text: "Get your free quote and slot confirmation the same day." },
  { icon: Sparkles, title: "Crew arrives with full kit", text: "Machines, chemicals and checklist — you just open the door." },
];

export default function Booking() {
  return (
    <section
      id="book"
      data-testid="booking-section"
      className="bg-gradient-to-b from-white via-sapphire-light/60 to-sapphire-light py-16 sm:py-24 lg:py-32"
    >
      <div className="mx-auto grid max-w-7xl items-start gap-12 px-4 sm:px-6 lg:grid-cols-[1fr_1.1fr] lg:gap-16 lg:px-8">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-sapphire">Book now</p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Book online / submit an inquiry
          </h2>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-slate-600 sm:text-base">
            No advance payment. No spam calls. Just a quick form, a same-day quote, and a spotless space by the
            weekend.
          </p>

          <ol className="mt-8 space-y-5">
            {STEPS.map((s, i) => (
              <li key={s.title} className="flex items-start gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-sapphire text-white shadow-lg shadow-sapphire/25">
                  <s.icon className="h-5 w-5" />
                </span>
                <span>
                  <span className="block text-sm font-bold text-slate-900 sm:text-base">
                    <span className="mr-2 font-mono text-sapphire/50">0{i + 1}</span>
                    {s.title}
                  </span>
                  <span className="mt-1 block text-sm text-slate-600">{s.text}</span>
                </span>
              </li>
            ))}
          </ol>

          <div className="mt-8 flex flex-wrap gap-3">
            <a
              data-testid="booking-form-cta-button"
              href={FORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-sapphire px-6 py-3 text-sm font-bold text-white shadow-xl shadow-sapphire/25 transition-all duration-300 hover:-translate-y-0.5 hover:bg-sapphire-dark"
            >
              Open booking form
              <ArrowUpRight className="h-4 w-4" />
            </a>
            <a
              data-testid="booking-phone-cta-button"
              href={PHONE_TEL}
              className="inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-6 py-3 text-sm font-bold text-slate-800 transition-all duration-300 hover:border-sapphire hover:text-sapphire"
            >
              <Phone className="h-4 w-4" />
              {PHONE_DISPLAY}
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-2xl shadow-sapphire/10">
            <div className="flex items-center justify-between border-b border-slate-100 px-6 py-4">
              <p className="text-sm font-bold text-slate-900">Quick Booking Form</p>
              <span className="rounded-full bg-whatsapp/10 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-whatsapp-dark">
                Replies same day
              </span>
            </div>
            <iframe
              data-testid="embedded-google-form-iframe"
              src={FORM_URL}
              title="swaclean Facility Services booking inquiry form"
              className="h-[540px] w-full"
              loading="lazy"
            >
              Loading…
            </iframe>
            <p className="border-t border-slate-100 px-6 py-3 text-center text-xs text-slate-500">
              Form not loading?{" "}
              <a
                data-testid="booking-form-fallback-link"
                href={FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="font-bold text-sapphire underline underline-offset-2"
              >
                Open it in a new tab
              </a>
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
